export default function ProjectPlaceholder({ title, category, className = "" }) {
  // Deterministic color from title
  const palette = ["#BE1E2D", "#004B87", "#006838", "#0A0A0A", "#52525B"];
  const idx = (title || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0) % palette.length;
  const bg = palette[idx];
  return (
    <div
      className={`relative overflow-hidden flex items-end p-6 ${className}`}
      style={{ backgroundColor: bg }}
    >
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 15%, rgba(255,255,255,0.6), transparent 55%)",
        }}
      />
      <div className="absolute top-6 left-6 mono-label text-white/70">
        {category || "Project"}
      </div>
      <div className="absolute top-6 right-6 w-8 h-px bg-white/40" />
      <div className="relative z-10 font-display text-white text-3xl md:text-4xl leading-[1.05] tracking-tight">
        {title}
      </div>
    </div>
  );
}
